import { Navigate } from 'react-router-dom';
export default function RsvpPage() {
  return <Navigate to="/meals" replace />;
}
